import React from 'react';
import UsersTable from './table/UsersTable';

/**
 * Users Page (Index)
 *
 * @component
 * @description Este componente es el punto de entrada para la sección de usuarios. 
 * Renderiza la tabla principal de usuarios (`UsersTable`) que muestra todos los registros de usuarios y permite su gestión.
 *
 * @example
 * // Se usa en rutas como /admin/users o similar
 * <UsersPage />
 */

const UsersPage = () => (
    <UsersTable />
);

export default UsersPage;